var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectclient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#2D66AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.5C18.6739 7.5 17.4021 8.02678 16.4645 8.96447C15.5268 9.90215 15 11.1739 15 12.5C15 13.8261 15.5268 15.0979 16.4645 16.0355C17.4021 16.9732 18.6739 17.5 20 17.5C21.3261 17.5 22.5979 16.9732 23.5355 16.0355C24.4732 15.0979 25 13.8261 25 12.5C25 11.1739 24.4732 9.90215 23.5355 8.96447C22.5979 8.02678 21.3261 7.5 20 7.5ZM17.5 12.5C17.5 11.837 17.7634 11.2011 18.2322 10.7322C18.7011 10.2634 19.337 10 20 10C20.663 10 21.2989 10.2634 21.7678 10.7322C22.2366 11.2011 22.5 11.837 22.5 12.5C22.5 13.163 22.2366 13.7989 21.7678 14.2678C21.2989 14.7366 20.663 15 20 15C19.337 15 18.7011 14.7366 18.2322 14.2678C17.7634 13.7989 17.5 13.163 17.5 12.5ZM26.25 20H13.75C12.7554 20 11.8016 20.3951 11.0983 21.0983C10.3951 21.8016 10 22.7554 10 23.75C10 26.54 11.1475 28.775 13.03 30.2875C14.8825 31.775 17.3675 32.5 20 32.5C22.6325 32.5 25.1175 31.775 26.97 30.2875C28.85 28.775 30 26.54 30 23.75C30 22.7554 29.6049 21.8016 28.9017 21.0983C28.1984 20.3951 27.2446 20 26.25 20ZM13.75 22.5H26.25C26.5815 22.5 26.8995 22.6317 27.1339 22.8661C27.3683 23.1005 27.5 23.4185 27.5 23.75C27.5 25.7925 26.6875 27.3075 25.405 28.3375C24.09 29.3925 22.2 30 20 30C17.8 30 15.91 29.3925 14.595 28.3375C13.3125 27.3075 12.5 25.7925 12.5 23.75C12.5 23.4185 12.6317 23.1005 12.8661 22.8661C13.1005 22.6317 13.4185 22.5 13.75 22.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectclient);
export default __webpack_public_path__ + "static/media/directclient.1a21c28107653dafb3e0a597517de9fc.svg";
export { ForwardRef as ReactComponent };